import { useEffect } from "react";

const setMeta = (name, content) => {
  let tag = document.head.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
  return tag;
};

/**
 * Gives a route its own <title> and meta description (index.html only has the
 * site-wide defaults), and optionally asks search engines not to index it.
 * The previous values are restored when the page unmounts.
 */
const usePageMeta = ({ title, description, noindex = false }) => {
  useEffect(() => {
    const previousTitle = document.title;
    const descriptionTag = document.head.querySelector(
      'meta[name="description"]'
    );
    const previousDescription = descriptionTag?.getAttribute("content");

    document.title = title;
    if (description) setMeta("description", description);
    const robotsTag = noindex ? setMeta("robots", "noindex") : null;

    return () => {
      document.title = previousTitle;
      if (descriptionTag && previousDescription != null) {
        descriptionTag.setAttribute("content", previousDescription);
      }
      robotsTag?.remove();
    };
  }, [title, description, noindex]);
};

export default usePageMeta;
